import { render, staticRenderFns } from "./CareRenewDetail.vue?vue&type=template&id=4937846c&scoped=true"
import script from "./CareRenewDetail.vue?vue&type=script&lang=js"
export * from "./CareRenewDetail.vue?vue&type=script&lang=js"
import style0 from "./CareRenewDetail.vue?vue&type=style&index=0&id=4937846c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937846c",
  null
  
)

export default component.exports